/**
 * @generated SignedSource<<c6770f915ad5824ba08605cd52fdc2a1>>
 * @relayHash 73bfbcdd7827d0d9020839eddbccc4fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe06f62997e020691a5c30e3df796af933531d6afecff4a8cbd40792e66b36d2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueHistory_RefetchQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
  last?: number | null | undefined;
  orderBy?: string | null | undefined;
};
export type IssueHistory_RefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueHistoryFragment">;
  } | null | undefined;
};
export type IssueHistory_RefetchQuery = {
  response: IssueHistory_RefetchQuery$data;
  variables: IssueHistory_RefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "formattedValue"
},
v12 = {
  "kind": "ScalarField",
  "name": "displayValue"
},
v13 = {
  "kind": "ScalarField",
  "name": "value"
},
v14 = {
  "kind": "ScalarField",
  "name": "avatarUrl"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      {
        "kind": "ScalarField",
        "name": "categoryId"
      },
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "type": "JiraHistoryStatusFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      {
        "concreteType": "JiraWorklog",
        "kind": "LinkedField",
        "name": "worklog",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "worklogId"
          },
          {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "timeSpent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "timeInSeconds"
              }
            ]
          },
          {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "workDescription",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraADF",
                "kind": "LinkedField",
                "name": "adfValue",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "json"
                  },
                  {
                    "concreteType": "JiraAdfToConvertedPlainText",
                    "kind": "LinkedField",
                    "name": "convertedPlainText",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "plainText"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "JiraHistoryWorkLogFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v12/*: any*/)
    ],
    "type": "JiraHistoryAssigneeFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v13/*: any*/),
      (v12/*: any*/),
      (v11/*: any*/),
      {
        "kind": "ScalarField",
        "name": "iconUrl"
      },
      {
        "kind": "ScalarField",
        "name": "absoluteIconUrl"
      }
    ],
    "type": "JiraHistoryPriorityFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      {
        "concreteType": "JiraHistoryResponder",
        "kind": "LinkedField",
        "name": "responders",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ari"
          },
          (v15/*: any*/),
          (v10/*: any*/),
          (v14/*: any*/)
        ]
      }
    ],
    "type": "JiraHistoryRespondersFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "type": "JiraHistoryGenericFieldValue"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueHistory_RefetchQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "IssueHistoryFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueHistory_RefetchQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraIssueHistoryConnection",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraHistoryActivityFeedItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "i18nDescription"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldDisplayName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "timestamp"
                          },
                          {
                            "concreteType": "JiraHistoryFieldSchema",
                            "kind": "LinkedField",
                            "name": "fieldSchema",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "customFieldType"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDueToRedaction"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDueToRedactionRestore"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "from",
                            "plural": false,
                            "selections": (v16/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": (v16/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "actor",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "picture"
                              },
                              (v8/*: any*/)
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasPreviousPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v9/*: any*/),
                "filters": [
                  "orderBy"
                ],
                "handle": "connection",
                "key": "IssueHistory_history",
                "kind": "LinkedHandle",
                "name": "history"
              }
            ],
            "type": "JiraIssue"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fe06f62997e020691a5c30e3df796af933531d6afecff4a8cbd40792e66b36d2",
    "metadata": {},
    "name": "IssueHistory_RefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ee576f8f8aa6ff147c359258d1d2457b";

export default node;
